import { render, staticRenderFns } from "./ModalActionExtraFieldRule.vue?vue&type=template&id=1cbba75b&"
import script from "./ModalActionExtraFieldRule.vue?vue&type=script&lang=js&"
export * from "./ModalActionExtraFieldRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports